import { createContext } from 'react';
export default createContext({ authorized : false , setAuthorized:()=>{} , companyConfig : {} });